import * as React from "react";

import ModalComponent from "./ModalComponent";
import Config from "../../Config";
import ANPObjectCreator from "../../utils/ANPObjectCreator";

import '../../styles/Modal.css'
import '../../styles/Widget.css'
import StateGlobal from "../../StateGlobal";

/**
 * Modal saving template
 */
export default class TemplateSave extends ModalComponent
{
    constructor(props)
    {
        super(props);
        this.state = {
            templateName: "",
            savingInProgress: false,
            savingSucceeded: false,
            displayError: false,
            errorMessage: "",
            errorMessageDefault: Config.strings.errorMessages.saving.default,
        };

        this.inProgressLabel = React.createRef();

        StateGlobal.getState();
    }

    saveTemplate = async () =>
    {
        this.setState({
            savingInProgress: true
        });

        const sName = this.state.templateName;

        try
        {
            if (!sName)
            {
                throw new Error(Config.strings.errorMessages.saving.emptyName);
            }

            if (this.inProgressLabel.current)
            {
                this.inProgressLabel.current.innerText = Config.strings.messages.saving.inProgressFileParsing;
            }

            const sCurrentFileEncoded = await ANPObjectCreator.getCurrentFileEncoded();

            if (this.inProgressLabel.current)
            {
                this.inProgressLabel.current.innerText = Config.strings.messages.saving.inProgressCreateObj;
            }

            let aSavedObjData = await ANPObjectCreator.createTemplateDocObject(sName);

            if (this.inProgressLabel.current)
            {
                this.inProgressLabel.current.innerText = Config.strings.messages.saving.inProgressAssignUser;
            }
            await ANPObjectCreator.attachCurrentUserToObject({
                objId: aSavedObjData.docObject.id
            });
            if (this.inProgressLabel.current)
            {
                this.inProgressLabel.current.innerText = Config.strings.messages.saving.inProgressAttachDoc;
            }

            const sFileName = sName.replace(/#|%|&|{|}|\\|<|>|\*|\?|\/|\$|!|'|"|:|@/g, "_");
            if(sFileName.valueOf() !== sName.valueOf()){
                console.log("Changing file name from '" + sName + "' to '" + sFileName + "'.");
            }

            await ANPObjectCreator.attachCurrentDocToObject({
                objId: aSavedObjData.docObject.id,
                name: sFileName,
                fileEncoded: sCurrentFileEncoded
            });
            this.state.savingSucceeded = true;
            StateGlobal.setTemplateJustCreated();
        } catch (aEx)
        {
            let sMessage = Config.strings.errorMessages.saving.accessErrorRepo;
            if ("409: exists" === sMessage)
            {
                sMessage = Config.strings.errorMessages.saving.nameExists;
            }
            if (sMessage.startsWith("Word file error"))
            {
                sMessage = Config.strings.errorMessages.saving.cannotParseFile;
            }
            this.state.displayError = true;
            this.state.errorMessage = sMessage;
            console.error(aEx);
        } finally
        {
            this.setState({
                savingInProgress: false
            });
        }
    }

    resetErrorDisplay = () =>
    {
        if (this.state.displayError)
        {
            this.setState({ displayError: false })
        }
    }

    resetModal = () =>
    {
        this.state.savingSucceeded = false;
        this.state.savingInProgress = false;
        this.state.displayError = false;
    }

    render()
    {
        const { sTitle, sConfirmLabel, sRejectLabel } = this.props;

        return (
            this.state.openModal ?
                <div className="PopupBackground">
                    <div className="PopupContent">
                        <h3 className="Modal__label">{sTitle}</h3>
                        {
                            this.state.displayError &&
                            <h4 className="App__errorMessage" >
                                {this.state.errorMessage ? this.state.errorMessage : this.state.errorMessageDefault}
                            </h4>
                        }
                        <input
                            className="wrcWidget__input"
                            placeholder="template name"
                            onChange={(aEvent) =>
                            {
                                this.state.templateName = aEvent.target.value;
                                this.resetErrorDisplay();
                            }}
                        />
                        {
                            !this.state.savingInProgress ?
                                (!this.state.savingSucceeded ?
                                    <button className="wrcButton wrcButton--confirm" onClick={this.saveTemplate}>
                                        {sConfirmLabel}
                                    </button> :
                                    <h3 className="App__infoMessage">{Config.strings.messages.saving.succeeded}</h3>
                                ) :
                                // <h3 className="App__infoMessage" ref={this.inProgressLabel}>{Config.strings.messages.saving.inProgress}</h3>
                                <h3 className="App__infoMessage" ref={this.inProgressLabel}>{Config.strings.messages.saving.inProgressCreateObj}</h3>
                        }
                        {
                            !this.state.savingInProgress ?
                                <button className="wrcButton wrcButton--confirm" onClick={this.toggleModal}>
                                    {!this.state.savingSucceeded ? sRejectLabel : Config.strings.messages.buttonActions.btnOk}
                                </button> :
                                null
                        }
                    </div>
                </div>
                : null
        )
    }
}